// extracted by mini-css-extract-plugin
export default {"backLink":"NewCanvass_backLink__ZgEcN","backIcon":"NewCanvass_backIcon__91K7Q","backText":"NewCanvass_backText__oN9Zh"};